import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import useAlert from "@hooks/useAlert";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Grid,
  Box,
  Typography,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styled from 'styled-components';
import WebService from '../util/webService';
import useSnackbar from '../hooks/useSnackbar';
import { setAccount } from '../redux/actions/accountAction';
import { isAdmin, isStringNullOrEmpty } from '../util/helper';
import useIndicator from "@hooks/useIndicator";
import { useTheme } from '@mui/material/styles';
import { isExpired, decodeToken } from "react-jwt";
import no_image from '@images/no_image.png'
import logo from '@images/logo_white.png'
import logoText from '@images/logo_green.png'
import logo140 from '@images/icon_140.png'
// mui의 css 우선순위가 높기때문에 important를 설정 - 실무하다 보면 종종 발생 우선순위 문제
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

//
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`;

export const afterLogin = async (resp, dispatch) => {
  const repMessage = JSON.parse(resp.repMessage)
  const account = JSON.parse(repMessage.account)
  dispatch(setAccount(account))

  const token = repMessage.token
  const decoded = decodeToken(token)

  const accessToken = repMessage.accessToken
  localStorage.setItem('accessToken',accessToken)

  const refreshToken = repMessage.refreshToken
  localStorage.setItem('refreshToken', refreshToken)

  const deviceId = repMessage.deviceId
  localStorage.setItem('deviceId', deviceId )

  return ''
}

export const processLogin = async(url, data, dispatch) => {
  const resp = await WebService.post(url, data)
  if(resp.repCode !== 'ack') {
    // alert(resp.repMessage)
    return resp.repMessage
  }

  return afterLogin(resp, dispatch)

  /*
  const repMessage = JSON.parse(resp.repMessage)
  const account = JSON.parse(repMessage.account)
  dispatch(setAccount(account))

  const token = repMessage.token
  const decoded = decodeToken(token)

  const accessToken = repMessage.accessToken
  localStorage.setItem('accessToken',accessToken)

  const refreshToken = repMessage.refreshToken
  localStorage.setItem('refreshToken', refreshToken)

  const deviceId = repMessage.deviceId
  localStorage.setItem('deviceId', deviceId )

  return ''
  */
}

const LoginPage = () => {
  const theme = useTheme();
  const navigate = useNavigate()
  const [loginId, set_loginId] = useState('')
  const [password, set_password] = useState('')
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dispatch = useDispatch()
  const {alert, renderAlert} = useAlert()
  const buttonRef = useRef(null)
  const qrHandler = useState(false)
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click();
    }
  };


  const canLogin = () => {
    return loginId && password
  }

  const onLogin = async () => {
    const url = '/login'
    if(isStringNullOrEmpty(loginId) || isStringNullOrEmpty(password)) {
      openSnackbar('아이디 또는 패스워드를 입력하세요.')
      return
    }
    const data = {loginId: loginId, password: password}
    const ret = await processLogin(url, data, dispatch)
    if(ret != '') {
      alert(ret)
      return
    }
    navigate('/')

  }


  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
		<>
			<Container component='main' maxWidth='xs'>
				<CssBaseline />
				<Box
					sx={{
						marginTop: 8,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}>
            {/* <Avatar sx={{ m: 1, bgcolor: "primary.bar" }} /> */}
          <div style={{width:'100%', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
            <Typography>트레이딩 로그인</Typography>
          </div>

					<Boxs component='form' noValidate sx={{ mt: 3 }}>
						<FormControl component='fieldset' variant='standard'>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<TextField
										required
										autoFocus
										fullWidth
										type='text'
										id='loginId'
										name='loginId'
										label='아이디'
                    size='md'
										onChange={(e) => {
											set_loginId(e.target.value)
										}}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										required
										fullWidth
										type='password'
										id='password'
										name='password'
										label='패스워드'
                    size='md'
										onChange={(e) => {
											set_password(e.target.value)
										}}
									/>
								</Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    ref={buttonRef}
                    variant='contained'
                    size='large'
                    disabled={!canLogin()}
                    onClick={() => onLogin()}>

                    로그인
                  </Button>
                </Grid>
							</Grid>

              {/*
              <Button
                fullWidth
                variant='contained'
                sx={{ mt: 2 }}
                color='info'
                size='large'
                onClick={() => {
                  navigate("/register/company")
                }}>
                위탁업체 등록
              </Button>
              */}

						</FormControl>
					</Boxs>
				</Box>
			</Container>
			{renderIndicator()}
      {renderAlert()}
		</>
	)
};

export default LoginPage;
